import React, { useCallback } from 'react';

import LoadingAnimation from 'components/loading-animation';
import OfferRedemptionModal from 'components/offer-redemption-modal';
import { logOfferClick } from 'components/offers/custom-events';
import { ResponsiveCarousel } from 'components/responsive-carousel';
import useOffersRefresh from 'hooks/use-offer-refresh';
import { useOffersModal } from 'hooks/use-offers-modal';
import { useMParticleContext } from 'state/mParticle';
import { useOffersContext } from 'state/offers';
import { findOfferIndexByUniqId, getUniqIdForOffer } from 'utils/offers';

import Offer from './offer';
import { OffersList } from './styled';

const Offers: React.FC<{ className?: string }> = ({ className }) => {
  const offersCtx = useOffersContext();
  const mParticle = useMParticleContext();
  const { modalIsOpen, openModal, closeModal } = useOffersModal(offersCtx);
  const { offers: filteredOffers, loading, offersFeedback, selectOfferById } = offersCtx;

  useOffersRefresh();

  const makeHandleOfferClick = useCallback(
    (id: string) => () => {
      const offerIndex = findOfferIndexByUniqId(id, filteredOffers);
      if (offerIndex >= 0) {
        const selectedOffer = filteredOffers[offerIndex];
        logOfferClick(selectedOffer, offerIndex, filteredOffers.length, mParticle);
      }

      selectOfferById(id);
      openModal();
    },
    [filteredOffers, selectOfferById, openModal, mParticle]
  );

  return (
    <>
      <OffersList className={className}>
        {loading && !offersFeedback ? (
          <LoadingAnimation fillColor={Styles.color.primary} />
        ) : (
          <ResponsiveCarousel>
            {filteredOffers.map((offer, i) => {
              const offerId = getUniqIdForOffer({ id: offer._id, token: offer.tokenId });
              const handleOfferClick = makeHandleOfferClick(offerId);
              return (
                <Offer
                  key={`${offerId}_${i}`}
                  offer={offer}
                  offerFeedback={(offersFeedback || {})[offerId]}
                  onClick={handleOfferClick}
                />
              );
            })}
          </ResponsiveCarousel>
        )}
      </OffersList>
      <OfferRedemptionModal modalIsOpen={modalIsOpen} closeModal={closeModal} />
    </>
  );
};

export default Offers;
